import { IraUserTransactions } from 'screens';

const ReroutingToIraUserTransactions = (): JSX.Element => <IraUserTransactions />;

export default ReroutingToIraUserTransactions;
